/** Strings owned by `src/manage/overview/` — "Beheer › Overzicht"
 * (PLAN-FASE3.md WP-05): the platform-staff-only KPI overview. No NPS or
 * AI-summary card — out of scope, see AdminOverviewPage.tsx. */
export const manageOverview = {
  page: {
    title: 'Übersicht',
    lead: 'Plattformweite Kennzahlen: Umsatz, aktive Unternehmen und Nutzer sowie Kundenbindung.',
    activeCompanies: 'Aktive Unternehmen',
    activeUsers: 'Aktive Nutzer',
    revenueThisMonth: 'Umsatz diesen Monat',
    retention: 'Kundenbindung (Monat zu Monat)',
    retentionUnavailable: 'Noch keine Daten',
    retentionDetail: '{{retained}} von {{total}} Unternehmen gehalten',
  },
} as const;
